export default "__VITE_ASSET__qoSObarK__"